<template>
  <div class="layout-config-dialog">
    <div class="dialog-content">
      <div class="module-list-container">
        <el-scrollbar class="scrollbar">
          <div class="module-list">
            <div class="module-group" v-for="group in moduleGroups" :key="group.type">
              <div class="group-header" @click.stop="group.expand = !group.expand">
                <span class="group-title">{{ group.title }}</span>
                <i :class="group.expand ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"></i>
              </div>
              <div v-if="group.expand" class="group-list">
                <div v-for="node in group.modules" :key="node.id" class="group-item"
                  @click.stop="toggleModuleNode(node)">
                  <div class="node-content">
                    <span class="item-title" :title="getNodeTitle(node)">{{ getNodeTitle(node) }}</span>
                  </div>
                  <div class="node-actions">
                    <span class="item-count">{{ node.resourceCount || 0 }}</span>
                    <el-checkbox v-model="node.check" @change="updateSelection(node)" @click.stop></el-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="dialog-footer">
        <el-button class="w-24" @click="$emit('close')">取消</el-button>
        <el-button type="primary" class="w-24" @click="handleSubmit">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { valueByLanguage } from "@/utils/college";

export default {
  name: "LayoutConfigDialog",
  props: {
    currentLayoutId: {
      type: [Number, String],
      default: null
    },
    selectedIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      moduleGroups: [
        { title: "banner素材库", expand: true, type: "1", modules: [] }, // BANNER = "1"
        { title: "卡片素材库", expand: true, type: "2", modules: [] } // CARD = "2"
      ],
      selectedData: [],
      delSelectedData: []
    };
  },
  mounted() {
    this.getModuleData();
  },
  methods: {
    async getModuleData() {
      // 取所有模块（素材中心：resourceType=RESOURCE），分别按 type=1/2 拉（BANNER=1, CARD=2）
      await Promise.all(
        this.moduleGroups.map(async (group) => {
          const res = await api.getIndexConfigModulesList({
            page: 1,
            pageSize: 2000,
            resourceType: "RESOURCE",
            type: group.type
          });
          const items = (res.data && res.data.items) ? res.data.items : [];
          group.modules = items.map((m) => ({
            ...m,
            check: this.selectedIds.includes(m.id)
          }));
        })
      );

      // 预勾选：已在当前 layout 的模块，需要 layout 页面传 selectedIds；这里先不做（由外层 setCheck 逻辑处理）
    },
    getNodeTitle(node) {
      return valueByLanguage(node && node.name, "zh_CN", true) || node.title || node.id;
    },
    toggleModuleNode(node) {
      node.check = !node.check;
      this.updateSelection(node);
    },
    updateSelection(node) {
      // 简化：只根据当前 check 计算 selected/del
      if (node.check) {
        this.delSelectedData = this.delSelectedData.filter((id) => id !== node.id);
      } else if (!this.delSelectedData.includes(node.id)) {
        this.delSelectedData = [...this.delSelectedData, node.id];
      }
      this.selectedData = this.moduleGroups
        .flatMap((g) => g.modules)
        .filter((m) => m.check)
        .map((m) => m.id);
    },
    handleSubmit() {
      this.$emit("success", {
        selectedData: this.selectedData,
        delSelectedData: this.delSelectedData
      });
    }
  }
};
</script>

<style scoped>
.layout-config-dialog {
  display: flex;
  flex-direction: column;
}

.dialog-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.module-list-container {
  width: 100%;
  height: 400px;
  overflow: hidden;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.scrollbar {
  height: 100%;
}

.module-list {
  padding: 16px;
}

.module-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
}

.group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 8px 0;
}

.group-title {
  font-size: 14px;
  font-weight: 700;
  text-align: left;
  color: #303133;
}

.group-list {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-left: 12px;
}

.group-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s;
}

.group-item:hover {
  background: #f5f7fa;
}

.node-content {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.item-title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #606266;
}

.node-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}

.item-count {
  font-size: 14px;
  color: #909399;
  min-width: 30px;
  text-align: right;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
</style>
